
export const getCurrentEnv = () => {
    const origin = document.location.origin.toLowerCase();

    let env = "prod";
    if (process.env.REACT_APP_ENV) {
        env = process.env.REACT_APP_ENV;
    } else {
        if (origin.includes('-uat')) {
            env = "uat";
        } else if (origin.includes('-qa')) {
            env = "qa";
        } else if (origin.includes('-dev')) {
            env = "dev";
        }
    }

    return env;
};
